import Repository from '../Repository';

const url = '/subscription/pricing';

export default {
    getPricing() {
        return Repository.get(`${url}/`,{localLoading: true});
    },
}
